<template>
  <div class="row pt-2">
    <div class="col-12 col-md-6 px-0 pr-md-3">
      <label for="description">Quantidade Mínima de Caracteres</label>
      <base-input
        v-model="formData.min_length"
        @input="emitInput"
        :error="validateMinLength(formData.min_length)"
        mask="integer"
        placeholder="Ex: 30"
      />
    </div>
    <div class="col-12 col-md-6 px-0">
      <label for="description">Quantidade Máxima de Caracteres</label>
      <base-input
        v-model="formData.max_length"
        @input="emitInput"
        :error="validateMaxLength(formData.max_length)"
        mask="integer"
        placeholder="Ex: 300"
      />
    </div>
  </div>
</template>

<script>
const DATABASE_MAX_LENGTH = 4000

export default {
  name: "TextAvaliationItemStrategy",
  props: {
    value: {
      type: Object,
      default: () => ({
        min_length: 0,
        max_length: DATABASE_MAX_LENGTH,
      }),
    },
  },
  methods: {
    emitInput() {
      this.$emit("input", this.formData);
    },
    validateMinLength(value) {
      if (value < 0) {
        return "O valor mínimo deve ser maior ou igual a 0";
      }
      if (value > this.formData.max_length) {
        return "O valor mínimo deve ser menor ou igual ao valor máximo";
      }
      if (value > DATABASE_MAX_LENGTH) {
        return `O valor mínimo deve ser menor ou igual a ${DATABASE_MAX_LENGTH}`;
      }
      return;
    },
    validateMaxLength(value) {
      if (value < 0) {
        return "O valor máximo deve ser maior ou igual a 0";
      }
      if (value < this.formData.min_length) {
        return "O valor máximo deve ser maior ou igual ao valor mínimo";
      }
      if (value > DATABASE_MAX_LENGTH) {
        return `O valor máximo deve ser menor ou igual a ${DATABASE_MAX_LENGTH}`;
      }
      return;
    },
  },
  computed: {
    formData: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },
}
</script>
